import React from "react"
import { cn } from "@/lib/utils"

export interface ChipProps {
  label: string
  icon?: React.ReactNode
  backgroundColor?: string
  textColor?: string
  className?: string
  showDot?: boolean
  dotColor?: string
}

export const Chip: React.FC<ChipProps> = ({
  label,
  icon,
  backgroundColor = "#FFFFFF",
  textColor = "#08090A",
  className,
  showDot = false,
  dotColor,
}) => {
  return (
    <div
      className={cn(
        "inline-flex items-center px-2 rounded-[48px] h-[24px] max-w-[112px] min-w-auto shrink-0 overflow-hidden border-[0.5px] border-[#cfcfcf] transition-colors duration-150 text-[11px] font-medium whitespace-nowrap gap-1.5",
        className
      )}
      style={{
        backgroundColor,
        color: textColor,
      }}
    >
      {showDot && (
        <div 
          className="size-2 rounded-full shrink-0" 
          style={{ backgroundColor: dotColor || "currentColor" }} 
        />
      )}
      {icon && <span className="shrink-0 flex items-center justify-center">{icon}</span>}
      <span className="truncate">{label}</span>
    </div>
  )
}
